
import { trackRegisterClick } from "../utils/analytics";
import { ensureRegistrationSessionId, trackRegistrationEvent } from "../utils/registrationTracking";

export function scrollToTop() {
    window.scrollTo(0, 0);
}

// export function scrollFunction() {
//     const navbar = document.getElementById('navbar');
//     const sticky = navbar.offsetTop;

//     if (window.scrollY >= sticky) {
//         navbar.classList.add("sticky");
//     } else {
//         navbar.classList.remove("sticky");
//     }
// }

export function login() {
    // const analytics = getAnalytics();
    // logEvent(analytics, 'login-button-clicked');
    window.open('https://app.egodziny.pl/', '_blank');
}

export function register(source = "menu_register") {
    trackRegisterClick(source);
    ensureRegistrationSessionId();
    trackRegistrationEvent("register_click", {
        source,
        timestamp: new Date().toISOString()
    });
    window.open('/register', '_self');
}

// export function appStoreClick() {
//     const analytics = getAnalytics();
//     logEvent(analytics, 'appstore-badge-clicked');
// }

// export function playStoreClick() {
//     const analytics = getAnalytics();
//     logEvent(analytics, 'playstore-badge-clicked');
// }
